import loanqReferButton from './loanqReferButton.component';
import stLoanqConfigure from './loanqConfigure.component';

export default angular
  .module('st.Integrations.LoanQ', ['st.Core', 'angular-cache'])
  .component('stLoanqConfigure', stLoanqConfigure)
  .component('stLoanqReferButton', loanqReferButton);
